import axios from '../request'

const hasValidOssFileUrlParams = (data) => {
  if (Array.isArray(data)) {
    return data.some(item => hasValidOssFileUrlParams(item))
  }

  if (data && typeof data === 'object') {
    return Object.values(data).some(item => hasValidOssFileUrlParams(item))
  }

  if (typeof data === 'string') {
    return data.trim() !== ''
  }

  return data !== null && data !== undefined && data !== ''
}

// 获取OSS临时访问路径
export const querySsoTempUrl = (data) => {
  return axios({
    url: `/basic/querySsoTempUrl`,
    method: 'post',
    data
  })
}

// 获取OSS上传Token
export const getOssUploadToken = (data) => {
  return axios({
    url: `/basic/getOssUploadToken`,
    method: 'post',
    data
  })
}

// 获取OSS上传Token免登录
export const getOssUploadTokenNoLogin = (data) => {
  return axios({
    url: `/basic/getOssUploadTokenNoLogin`,
    method: 'post',
    data
  })
}

// 文件路径获取Url
export const getOssFileUrl = (data) => {
  if (!hasValidOssFileUrlParams(data)) {
    return Promise.resolve({
      data: {
        succ: false,
        data: {}
      }
    })
  }

  return axios({
    url: `/user/ossDownLoadFileWithSTSByMap`,
    method: 'post',
    data
  })
}
